// extracted by mini-css-extract-plugin
module.exports = {"review-oparetion-table":"review-oparetion-table-05ea85201dd155baf6ca47dc09b5fa4f"};